import { render, staticRenderFns } from "./HeaderBarLogo.vue?vue&type=template&id=4d26f878&"
import script from "./HeaderBarLogo.vue?vue&type=script&lang=js&"
export * from "./HeaderBarLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports